import { Link, useSearchParams } from 'react-router-dom';
import LegalFooter from '../components/shared/LegalFooter';
import '../styles/global.css';

export default function EnrollSuccessPage() {
  // session_id is read from the Stripe Checkout redirect but intentionally
  // unused — we show a generic success message and make no backend calls.
  const [searchParams] = useSearchParams();
  // eslint-disable-next-line no-unused-vars
  const sessionId = searchParams.get('session_id');

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div className="topbar">
        <div className="topbar-logo">
          <div className="topbar-logo-dot" />
          Affordable Telecom LLC
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 480 }}>
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div
              aria-hidden="true"
              style={{
                width: 88, height: 88, borderRadius: '50%', background: 'var(--green)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px', boxShadow: '0 8px 24px rgba(0,196,159,0.3)',
              }}
            >
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 13l4 4L19 7" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--navy)', marginBottom: 8 }}>
              You're enrolled!
            </h1>
            <p style={{ color: 'var(--text-sub)', fontSize: 15, lineHeight: 1.6, maxWidth: 400, margin: '0 auto' }}>
              Welcome to Affordable Telecom internet service. Your subscription is now active.
            </p>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title">What happens next</div>
            </div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {[
                "You'll receive a welcome email shortly with your account details",
                'Service continues seamlessly — no installation needed',
                'Manage your plan, billing, and account in the tenant portal anytime',
              ].map((text, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div
                    aria-hidden="true"
                    style={{
                      flexShrink: 0, width: 24, height: 24, borderRadius: '50%',
                      background: 'rgba(0,196,159,0.12)', color: 'var(--green)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      marginTop: 1,
                    }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <span style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.5 }}>{text}</span>
                </div>
              ))}
            </div>
          </div>

          <Link to="/login" className="btn btn-primary btn-full" style={{ marginTop: 20, textDecoration: 'none' }}>
            Sign In to Tenant Portal
          </Link>
        </div>
      </div>

      <LegalFooter />
    </div>
  );
}
